import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { buyCourseApplication } from '../../slices/authSlice';
import { useDispatch } from 'react-redux';

const BuyCourse = () => {

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await buyCourseApp();
  };
  
  fetchData();
  },[token])

  const buyCourseApp = async () => {
    const response = await dispatch(buyCourseApplication({ token: token }))
    navigate('/cart')
  }

  return (
    <div>BuyCourse</div>
  )
}

export default BuyCourse;